import PropTypes from 'prop-types';
import { Component } from 'react';
import I18n from 'I18n';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ui-a... Remove this comment to see the full error message
import UIAvatar from 'ui-addon-avatars/UIAvatar';
import { Button } from 'foundations-components/transitional/components/Button';
import { Section } from 'foundations-components/transitional/components/Section';
import { Small } from 'foundations-components/transitional/components/Small';
import { Link } from 'foundations-components/transitional/components/Link';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { H2 } from 'foundations-components/transitional/components/H2';
import { Alert } from 'foundations-components/transitional/components/Alert';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class UserPreferencesGravatarUploader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: false,
      url: `https://www.gravatar.com/avatar/${props.emailHash}?s=100&d=404`
    };
  }
  componentDidMount() {
    const {
      url
    } = this.state;
    const testImage = new Image();
    testImage.onerror = () => {
      this.setState({
        error: true
      });
    };
    testImage.src = url;
  }
  maybeRenderAvatar() {
    const {
      error,
      url
    } = this.state;
    if (error) {
      return /*#__PURE__*/_jsx("div", {
        children: I18n.text('userPreferences.avatar.gravatar.noGravatar')
      });
    }
    return /*#__PURE__*/_jsx(UIAvatar, {
      size: "lg",
      src: url
    });
  }
  render() {
    const {
      onConfirm,
      onReject
    } = this.props;
    const {
      error
    } = this.state;
    return /*#__PURE__*/_jsxs(Modal, {
      use: "conversational",
      children: [/*#__PURE__*/_jsx(DialogHeader, {
        paddingBlockStart: "500",
        children: /*#__PURE__*/_jsx(H2, {
          children: I18n.text('userPreferences.avatar.gravatar.title')
        })
      }), /*#__PURE__*/_jsxs(DialogBody, {
        paddingBlockEnd: "500",
        children: [/*#__PURE__*/_jsx(Section, {
          children: /*#__PURE__*/_jsx(Small, {
            children: /*#__PURE__*/_jsx(Link, {
              href: "https://gravatar.com",
              external: true,
              children: error ? I18n.text('userPreferences.avatar.gravatar.setUpGravatar') : I18n.text('userPreferences.avatar.gravatar.change')
            })
          })
        }), /*#__PURE__*/_jsx(Section, {
          children: this.maybeRenderAvatar()
        }), /*#__PURE__*/_jsx(Alert, {
          type: "warning",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "userPreferences.avatar.usageWarning"
          })
        })]
      }), /*#__PURE__*/_jsxs(DialogFooter, {
        align: "center",
        children: [/*#__PURE__*/_jsx(Button, {
          onClick: onConfirm,
          disabled: error,
          use: "primary",
          children: I18n.text('userPreferences.avatar.actions.confirm')
        }), /*#__PURE__*/_jsx(Button, {
          onClick: onReject,
          children: I18n.text('userPreferences.avatar.actions.cancel')
        })]
      })]
    });
  }
}
UserPreferencesGravatarUploader.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onReject: PropTypes.func.isRequired,
  emailHash: PropTypes.string.isRequired
};
export default UserPreferencesGravatarUploader;